import Flex from '../Flex'
import Grid from '../Grid'
import Text from '../Text'

export type Props = {
  // icon render prop
  icon: () => JSX.Element
  title: string
  description?: string
  /** When set, description is rendered as HTML. Use only for trusted content. */
  descriptionHtml?: string
}

function IconDetailListItem(props: Props) {
  return (
    <Grid className="gap-4 grid-cols-auto-1fr">
      {props.icon()}
      <Flex container direction="column" className="gap-1">
        <Text variant="subheader" className="text-[#343434]">
          {props.title}
        </Text>
        <Text variant="body4">
          {props.descriptionHtml != null ? (
            <span dangerouslySetInnerHTML={{ __html: props.descriptionHtml }} />
          ) : (
            props.description
          )}
        </Text>
      </Flex>
    </Grid>
  )
}

export default IconDetailListItem
